export const ENVIRONMENT_MODE = process.env.REACT_APP_ENVIRONMENT;

export const GROUP_ADMIN_DOMAIN = process.env.REACT_APP_GROUP_ADMIN_DOMAIN;
export const USER_DOMAIN = process.env.REACT_APP_USER_DOMAIN;

export const IS_GROUP_ADMIN_APP = window.location.origin === GROUP_ADMIN_DOMAIN;
export const IS_USER_APP = window.location.origin === USER_DOMAIN;

export const URL_CONFIG = {
    API: {
        url: `${process.env.REACT_APP_API_URL}/api/v1/user`
    },
    SOCKET: {
        url: process.env.REACT_APP_SOCKET_URL
    }
};
